/** App languages other than English. English is the default title field. */
export const ALTERNATIVE_LANGUAGES = [
  { code: "ar", label: "Arabic" },
  { code: "zh", label: "Chinese" },
  { code: "nl", label: "Dutch" },
  { code: "fr", label: "French" },
  { code: "de", label: "German" },
  { code: "hi", label: "Hindi" },
  { code: "it", label: "Italian" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "pl", label: "Polish" },
  { code: "pt", label: "Portuguese" },
  { code: "es", label: "Spanish" },
  { code: "tr", label: "Turkish" },
];

/**
 * Fixed order for comma-separated title paste (includes English first).
 * Example: Cloud,Wolke,Nube,Nuage,Nuvem,Nube,Wolk,Chmura,Bulut,سحابة,बादल,云,雲,구름
 */
export const TITLE_PASTE_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "de", label: "German" },
  { code: "es", label: "Spanish" },
  { code: "fr", label: "French" },
  { code: "pt", label: "Portuguese" },
  { code: "it", label: "Italian" },
  { code: "nl", label: "Dutch" },
  { code: "pl", label: "Polish" },
  { code: "tr", label: "Turkish" },
  { code: "ar", label: "Arabic" },
  { code: "hi", label: "Hindi" },
  { code: "zh", label: "Chinese" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
];

export const TITLE_PASTE_ORDER_HINT = TITLE_PASTE_LANGUAGES.map(
  ({ code }) => code
).join(", ");

/**
 * Parse a comma-separated title paste into English + alternative names.
 * Values are positional; missing slots stay blank; extras are ignored.
 */
export const parseTitlePaste = (raw) => {
  const parts = String(raw ?? "")
    .split(",")
    .map((part) => part.trim());
  const englishTitle = parts[0] || "";
  const alternativeNames = emptyAlternativeNames();
  TITLE_PASTE_LANGUAGES.forEach(({ code }, index) => {
    if (code === "en") return;
    alternativeNames[code] = parts[index] || "";
  });
  return {
    englishTitle,
    alternativeNames,
    expectedCount: TITLE_PASTE_LANGUAGES.length,
    receivedCount: parts.length,
  };
};

export const emptyAlternativeNames = () =>
  Object.fromEntries(ALTERNATIVE_LANGUAGES.map(({ code }) => [code, ""]));

export const alternativeNamesFromRecord = (record) => {
  const stored = record?.localizedTitles || {};
  const names = emptyAlternativeNames();
  ALTERNATIVE_LANGUAGES.forEach(({ code }) => {
    const value = stored[code];
    names[code] = typeof value === "string" ? value : "";
  });
  return names;
};

/** Full map, including blanks, so an edit can clear a language. */
export const alternativeNamesPayload = (names) => {
  const out = {};
  ALTERNATIVE_LANGUAGES.forEach(({ code }) => {
    out[code] = (names?.[code] || "").trim();
  });
  return out;
};

export const alternativeNameOverLimit = (names, maxLength) =>
  ALTERNATIVE_LANGUAGES.find(
    ({ code }) => (names?.[code] || "").trim().length > maxLength
  );
